var autoLoadDuration = 4;
var eventList = ["keydown", "mousemove", "wheel", "touchmove", "touchstart", "touchend"];
var autoLoadTimeout = setTimeout(runScripts, autoLoadDuration * 1000);
eventList.forEach(function(event) {
    window.addEventListener(event, triggerScripts, { passive: true })
});
function triggerScripts() { 
    runScripts();
    clearTimeout(autoLoadTimeout);
    eventList.forEach(function(event) {
         window.removeEventListener(event, triggerScripts, { passive: true });
    });
} 
function runScripts() {
    document.querySelectorAll("script[delay]").forEach(function(scriptTag) {
        var script = document.createElement("script");
        Array.prototype.forEach.call(scriptTag.attributes, function(attr) {
            if (attr.name !== "delay") script.setAttribute(attr.name, attr.value);
        });
        script.async = false;
        script.src = scriptTag.getAttribute("delay");
        scriptTag.parentNode.replaceChild(script, scriptTag);
    });
}